module.exports = __webpack_public_path__ + "static/media/sylv.005ea4ba.png";